export default __webpack_public_path__ + "guide--imagery-naip-in-studio-480-1c15e6077c2e11d6947e1d96ba509dcd.png";